<template>
    <div class="py-4">
        <header class="pb-4">
            <div class="container-fluid">
                <div class="row align-items-end">
                    <div class="col-sm col-12">
                        <h1 class="h2 ls-tight">Reportes</h1>
                    </div>
                </div>
            </div>
        </header>
        <main>
            <div class="container-fluid">
                <div class="vstack gap-4">
                    <div class="row">
                        <div class="col-lg-9">
                            <div class="row">
                                <div class="col-lg-4 mb-3">
                                    <router-link :to="{ name: 'ReportPackageByWeight' }">
                                        <div class="card">
                                            <div class="card-body">
                                                <div class="d-block text-center">
                                                    <div
                                                        class="icon icon-shape rounded-3 bg-soft-primary text-primary text-lg me-4 mb-3">
                                                        <i class="bi bi-box"></i>
                                                    </div>
                                                    <div>
                                                        <h5 class="mb-1">Paquete por peso</h5>
                                                        <small class="d-block text-xs text-muted">Generar
                                                            Reporte</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                                <div class="col-lg-4 mb-3">
                                    <router-link :to="{ name: 'ReportRecovery' }">
                                        <div class="card">
                                            <div class="card-body">
                                                <div class="d-block text-center">
                                                    <div
                                                        class="icon icon-shape rounded-3 bg-soft-danger text-danger text-lg me-4 mb-3">
                                                        <i class="bi bi-arrow-clockwise"></i>
                                                    </div>
                                                    <div>
                                                        <h5 class="mb-1">Recuperación</h5>
                                                        <small class="d-block text-xs text-muted">Generar
                                                            Reporte</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                                <div class="col-lg-4 mb-3">
                                    <router-link :to="{ name: 'ReportSalesTax' }">
                                        <div class="card">
                                            <div class="card-body">
                                                <div class="d-block text-center">
                                                    <div
                                                        class="icon icon-shape rounded-3 bg-dark text-white text-lg me-4 mb-3">
                                                        <i class="bi bi-currency-dollar"></i>
                                                    </div>
                                                    <div>
                                                        <h5 class="mb-1">Impuesto de ventas</h5>
                                                        <small class="d-block text-xs text-muted">Generar
                                                            Reporte</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                                <div class="col-lg-4 mb-3">
                                    <router-link :to="{ name: 'ReportAwb' }">
                                        <div class="card">
                                            <div class="card-body">
                                                <div class="d-block text-center">
                                                    <div
                                                        class="icon icon-shape rounded-3 bg-soft-info text-info text-lg me-4 mb-3">
                                                        <i class="bi bi-airplane"></i>
                                                    </div>
                                                    <div>
                                                        <h5 class="mb-1">Manifiestos</h5>
                                                        <small class="d-block text-xs text-muted">Generar
                                                            Reporte</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                                <div class="col-lg-4 mb-3">
                                    <router-link :to="{ name: 'ReportInvoice' }">
                                        <div class="card">
                                            <div class="card-body">
                                                <div class="d-block text-center">
                                                    <div
                                                        class="icon icon-shape rounded-3 bg-soft-success text-success text-lg me-4 mb-3">
                                                        <i class="bi bi-file-earmark-diff"></i>
                                                    </div>
                                                    <div>
                                                        <h5 class="mb-1">Facturación</h5>
                                                        <small class="d-block text-xs text-muted">Generar
                                                            Reporte</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                                <div class="col-lg-4 mb-3">
                                    <router-link :to="{ name: 'ReportRejected' }">
                                        <div class="card">
                                            <div class="card-body">
                                                <div class="d-block text-center">
                                                    <div
                                                        class="icon icon-shape rounded-3 bg-primary text-white text-lg me-4 mb-3">
                                                        <i class="bi bi-x-circle"></i>
                                                    </div>
                                                    <div>
                                                        <h5 class="mb-1">Rechazados</h5>
                                                        <small class="d-block text-xs text-muted">Generar
                                                            Reporte</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                                <div class="col-lg-4 mb-3">
                                    <router-link :to="{ name: 'ReportAffiliations' }">
                                        <div class="card">
                                            <div class="card-body">
                                                <div class="d-block text-center">
                                                    <div
                                                        class="icon icon-shape rounded-3 bg-orange text-white text-lg me-4 mb-3">
                                                        <i class="bi bi-people"></i>
                                                    </div>
                                                    <div>
                                                        <h5 class="mb-1">Afiliaciones</h5>
                                                        <small class="d-block text-xs text-muted">Generar
                                                            Reporte</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                                <!-- <div class="col-lg-4 mb-3">
                                    <router-link :to="{ name: 'ReportBillingGrowth' }">
                                        <div class="card">
                                            <div class="card-body">
                                                <div class="d-block text-center">
                                                    <div
                                                        class="icon icon-shape rounded-3 bg-danger text-white text-lg me-4 mb-3">
                                                        <i class="bi bi-graph-up-arrow"></i>
                                                    </div>
                                                    <div>
                                                        <h5 class="mb-1">Crecimiento de facturación</h5>
                                                        <small class="d-block text-xs text-muted">Generar
                                                            Reporte</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </router-link>
                                </div> -->
                                <div class="col-lg-4 mb-3">
                                    <router-link :to="{ name: 'ReportWerehouse' }">
                                        <div class="card">
                                            <div class="card-body">
                                                <div class="d-block text-center">
                                                    <div
                                                        class="icon icon-shape rounded-3 bg-info text-white text-lg me-4 mb-3">
                                                        <i class="bi bi-building"></i>
                                                    </div>
                                                    <div>
                                                        <h5 class="mb-1">Paquetes en bodega</h5>
                                                        <small class="d-block text-xs text-muted">Generar
                                                            Reporte</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <div class="form-group mb-3">
                                <input type="text" class="form-control form-control-sm" v-model="search"
                                    placeholder="Buscar..">
                            </div>
                            <template>
                                <v-data-table :headers="headers" :items="items" :search="search" dense hide-default-header hide-default-footer>
                                    <template v-slot:[`item.title`]="{ item }">
                                        <a :href="endpoint.slice(0, -6) + 'v1/reports/my/' + item.hash" class="text-decoration-none" target="_blank">
                                            <div class="d-flex gap-2 align-items-center py-2">
                                                <div
                                                    :class="item.class"
                                                    class="icon icon-shape rounded-3 text-lg me-4">
                                                    <i :class="item.icon"></i>
                                                </div>
                                                <div>
                                                    <h5 class="mb-1">{{ item.title }}</h5>
                                                    <small class="d-block text-xs text-muted">{{ item.created_at }}</small>
                                                </div>
                                            </div>
                                        </a>
                                    </template>
                                </v-data-table>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>
<script>
export default {
    data: () => ({
        search: '',
        headers: [
            { text: '', value: 'title', sortable: false },
        ],
        items: [],
        endpoint: process.env.API,
    }),
    created() {
        let vue = this
        axios({ url: '/reports/my', method: 'GET' })
            .then((resp) => {
                vue.items = resp.data
            })
    }
}
</script>
